
import Vue, { PropType } from 'vue'

import RPHAccordion from 'rph/molecules/RPHAccordion/index.vue'

import { IProduct } from '~/types/DTO/products'
import RPHProductMnns from 'rph/molecules/RPHProductMnns/index.vue'
import RPHButton from 'rph/atoms/RPHButton/index.vue'

export default Vue.extend({
  name: 'RPHProductSpecification',
  components: { RPHButton, RPHProductMnns, RPHAccordion },
  props: {
    data: {
      type: Object as PropType<IProduct>,
      default: () => {},
    },
  },
})
